import apiClient from "./apiClient";

export const authService = {
  async login(username, password) {
    const response = await apiClient.post("/api/auth/login", { username, password });
    const { access_token, user, password_change_required } = response.data;
    localStorage.setItem("access_token", access_token);
    localStorage.setItem("user", JSON.stringify(user));
    return { user, passwordChangeRequired: password_change_required || false };
  },

  async changePassword(currentPassword, newPassword) {
    const response = await apiClient.post("/api/auth/change-password", {
      current_password: currentPassword,
      new_password: newPassword,
    });
    const { access_token } = response.data;
    localStorage.setItem("access_token", access_token);
    // Clear must_change_password from stored user
    const stored = localStorage.getItem("user");
    if (stored) {
      const u = JSON.parse(stored);
      u.must_change_password = false;
      localStorage.setItem("user", JSON.stringify(u));
    }
    return response.data;
  },

  async register(username, email, password, registrationKey) {
    const response = await apiClient.post("/api/auth/register", {
      username,
      email,
      password,
      registration_key: registrationKey,
    });
    return response.data;
  },

  async getMe() {
    const response = await apiClient.get("/api/auth/me");
    return response.data;
  },

  logout() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
  },

  getCurrentUser() {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  },

  isAuthenticated() {
    return !!localStorage.getItem("access_token");
  },
};
